import { makeStyles } from '@material-ui/core';
import { Icon, IconButton, Typography } from '@material-ui/core';
import React, { Fragment, useCallback, useState } from 'react';
import { FormattedNumber } from 'react-intl';
import { useObservable } from 'react-use-observable';
import eduzzAccountsService from 'v2/services/eduzzAccount';

import type { IBankAccount } from 'v2/interfaces/financial';

interface IProps {
  value: number;
  bankAccount: IBankAccount;
}

const useStyles = makeStyles(() => ({
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

const ConfirmTransactionMessage = ({ value, bankAccount }: IProps) => {
  const classes = useStyles({});

  const [showBankAccount, setShowBankAccount] = useState(false);

  const handleShowBankAccount = useCallback(() => setShowBankAccount(!showBankAccount), [showBankAccount]);
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);

  const currency = user?.crossborder ? 'USD' : 'BRL';

  const hideNumber = (value: string) => {
    if (showBankAccount) return value;

    return value.replace(/[0-9]/g, '*');
  };

  return (
    <Fragment>
      <div>
        <Typography style={{ textAlign: 'center' }}>
          Você solicitou uma transferência no valor de{' '}
          <b>
            <FormattedNumber value={value} format={currency} />
          </b>
          .
          <br />
          Neste valor, serão descontados os encargos de transferência no valor de R$ 9,00. Então o valor total transferido para sua conta será de{' '}
          <b>
            <FormattedNumber value={value - 9} format={currency} />
          </b>
          .
          <br />O valor será transferido para sua conta bancária:
        </Typography>

        <div className={classes.iconContainer}>
          <div>
            Agência: {hideNumber(bankAccount.agency)}-{hideNumber(bankAccount.agency_digit)} Conta: {hideNumber(bankAccount.account)}-
            {hideNumber(bankAccount.account_digit)}
          </div>
          <IconButton onClick={handleShowBankAccount}>
            <Icon>visibility</Icon>
          </IconButton>
        </div>
        <div className='m8' />

        <Typography style={{ textAlign: 'center' }}>
          <b>Deseja continuar com a transação?</b>
        </Typography>
      </div>

      <div className='m16' />

      <Typography style={{ textAlign: 'center', fontSize: 12 }}>
        * Caso possua antecipações, o recebimento antes do prazo incorre em taxa administrativa de 2,99% + 0,1% por dia antecipado
      </Typography>
    </Fragment>
  );
};

export default ConfirmTransactionMessage;
